export default __webpack_public_path__ + "static/media/OldSansBlack.33216c24.ttf";